

import * as React from "react"
import * as TooltipPrimitive from "@radix-ui/react-tooltip"

import { cn } from "@/lib/utils"
import { useAppConfig } from "@/providers/config-provider"
import { getButtonColors } from "@/lib/button-colors"

const TooltipProvider = TooltipPrimitive.Provider

const Tooltip = TooltipPrimitive.Root

const TooltipTrigger = TooltipPrimitive.Trigger

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<
    typeof TooltipPrimitive.Content
  >
>(({ className, sideOffset = 4, style, ...props }, ref) => {
  const config = useAppConfig()
  // Always use API colors when available, fallback to primary
  const dynamicColors = getButtonColors(config)

  return (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          "z-50 overflow-hidden rounded-md px-3 py-1.5 text-xs animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
          "[background:var(--btn-primary-bg,hsl(var(--primary)))] [color:var(--btn-primary-text,hsl(var(--primary-foreground)))]",
          className
        )}
        style={
          {
            ...dynamicColors,
            ...style,
          } as React.CSSProperties
        }
        {...props}
      />
    </TooltipPrimitive.Portal>
  )
})
TooltipContent.displayName =
  TooltipPrimitive.Content.displayName

export {
  Tooltip,
  TooltipTrigger,
  TooltipContent,
  TooltipProvider,
}
